module.exports = __webpack_public_path__ + "static/media/dopuszczenie-C.8141c2cd.svg";